export default __webpack_public_path__ + "static/media/partners3.42f12ed0.png";